import '../styles.css';

import logo from '../assets/logo.jpeg';

import { Link } from 'react-router-dom';

import IconButton from '@mui/material/IconButton';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailIcon from '@mui/icons-material/Email';

function Footer() {
	return (
		<div className="footer">
			<div className="footer-content">
				<Link to="/">
					<img
						width={40}
						height={40}
						src={logo}
						alt=""
					/>
				</Link>
				<div className="footer-links">
					<a
						target="_blank"
						rel="noreferrer"
						href="https://instagram.com/apl.win?igshid=YmMyMTA2M2Y="
					>
						<IconButton>
							<InstagramIcon />
						</IconButton>
					</a>
					<a
						target="_blank"
						rel="noreferrer"
						href="https://mail.google.com/mail/u/0/?fs=1&tf=cm&source=mailto&to=hrishikeshmohan@apl.edu.in"
					>
						<IconButton>
							<EmailIcon />
						</IconButton>
					</a>
				</div>
			</div>
		</div>
	);
}

export default Footer;
